module.exports = __webpack_public_path__ + "img/g_mro_11.381c35f3.png";